import React, { useEffect } from 'react';

const JoinUsView = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const opportunities = [
        { 
            title: "Partner Pharmacy", 
            type: "Business Partner", 
            icon: "fa-store",
            description: "Join our network of trusted local pharmacies and grow your digital footprint.",
            criteria: [
                "Valid Pharmacy License (Retail/Wholesale)",
                "GST Registration Certificate",
                "Minimum 300 sq.ft retail space",
                "Computer with high-speed internet",
                "Ability to pack orders within 15 minutes"
            ]
        },
        { 
            title: "Delivery Fleet Partner", 
            type: "Logistics Partner", 
            icon: "fa-motorcycle",
            description: "Become a delivery partner and earn on your own schedule by delivering essential medicines.",
            criteria: [
                "Valid Driving License",
                "Own two-wheeler in good condition",
                "Smartphone (Android/iOS) with active data plan",
                "Clear background check",
                "Local area geographic knowledge"
            ]
        },
        { 
            title: "Health Professional", 
            type: "Medical Partner", 
            icon: "fa-user-md",
            description: "Provide online consultations and expert health advice to our growing user base.",
            criteria: [
                "Valid Medical Council Registration",
                "Minimum 2 years of clinical experience",
                "Digital prescription generation capability",
                "Strong communication skills",
                "Dedication to patient care and ethics"
            ]
        }
    ];

    return (
        <div className="min-h-screen bg-slate-50 py-12 px-4 sm:px-6">
            <div className="max-w-5xl mx-auto space-y-12">
                <div className="text-center space-y-4">
                    <h1 className="text-4xl md:text-5xl font-extrabold text-slate-800 tracking-tight">Join Our Platform</h1>
                    <p className="text-lg text-slate-500 max-w-2xl mx-auto">
                        Partner with QwickMed and be part of the revolution in digital healthcare delivery. Explore opportunities that fit your expertise.
                    </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                    {opportunities.map((opp, idx) => (
                        <div key={idx} className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden hover:shadow-lg hover:-translate-y-1 transition-all duration-300 flex flex-col">
                            <div className="p-8 bg-sky-50/50 border-b border-sky-100 flex flex-col items-center text-center">
                                <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center text-sky-600 shadow-sm border border-sky-100 mb-4 transform rotate-3">
                                    <i className={`fas ${opp.icon} text-2xl`}></i>
                                </div>
                                <h2 className="text-xl font-bold text-slate-800 mb-1">{opp.title}</h2>
                                <span className="text-xs font-bold uppercase tracking-wider text-sky-600 bg-sky-100 px-3 py-1 rounded-full">{opp.type}</span>
                            </div>
                            
                            <div className="p-6 flex-grow flex flex-col">
                                <p className="text-slate-600 text-sm mb-6 text-center">
                                    {opp.description}
                                </p>
                                
                                <div className="mb-6 flex-grow">
                                    <h3 className="text-sm font-bold text-slate-900 uppercase tracking-wider mb-3">Joining Criteria</h3>
                                    <ul className="space-y-2">
                                        {opp.criteria.map((criterion, cIdx) => (
                                            <li key={cIdx} className="flex items-start text-sm text-slate-600">
                                                <i className="fas fa-check-circle text-emerald-500 mt-1 mr-2 flex-shrink-0"></i>
                                                <span>{criterion}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                
                                <button className="w-full bg-slate-900 text-white px-6 py-3 rounded-xl font-bold hover:bg-sky-600 transition-colors shadow-sm">
                                    Apply Now
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="text-center bg-white p-8 rounded-3xl shadow-sm border border-slate-100 max-w-3xl mx-auto relative overflow-hidden">
                    <div className="absolute top-0 right-0 w-32 h-32 bg-sky-50 rounded-full blur-2xl -mr-16 -mt-16"></div>
                    <div className="absolute bottom-0 left-0 w-32 h-32 bg-emerald-50 rounded-full blur-2xl -ml-16 -mb-16"></div>
                    
                    <div className="relative z-10">
                        <h3 className="text-2xl font-bold text-slate-800 mb-3">Have questions?</h3>
                        <p className="text-slate-600 mb-6 max-w-lg mx-auto">
                            Need more information about our partnership programs and onboarding process? Our dedicated team is here to help.
                        </p>
                        <a href="mailto:partners@qwickmed.com" className="inline-flex items-center justify-center bg-sky-50 text-sky-700 font-bold px-6 py-3 rounded-xl hover:bg-sky-100 hover:text-sky-800 transition-colors">
                            <i className="fas fa-envelope mr-2"></i> Contact Partnerships Team
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JoinUsView;
